const ITEMS = [
  "Authentic Distillery Oak",
  "Precision Water-Jet Cut Stone",
  "65,000 BTU Clean Propane",
  "Hand-Burned Custom Crests",
  "Ontario Crafted",
  "Est. 2024",
];

const Diamond = () => (
  <span aria-hidden className="mx-8 inline-block h-1.5 w-1.5 rotate-45 bg-amber-500/80 shadow-ember-sm" />
);

export const Ribbon = () => {
  const row = (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center whitespace-nowrap">
          <span className="font-serif italic text-lg sm:text-xl text-stone-300/90">{item}</span>
          <Diamond />
        </span>
      ))}
    </div>
  );
  return (
    <div
      data-testid="editorial-ribbon"
      className="ribbon-paused relative overflow-hidden border-y border-amber-900/25 bg-[#0d0b09] py-5"
    >
      <div className="animate-ribbon flex w-max">
        {row}
        {row}
      </div>
    </div>
  );
};
